import moment from 'moment'
import createPaginationModule from '../generic/pagination'
import { createNotificationSmsAllLogsSearchInputs, createNotificationSmsAllLogsSuggestions } from './search-inputs'
import { formatTwilioError } from '@/utils/twilio-status'

// KPT-1117 (item 1): the "All" filter used to list sms_notification rows only,
// so UAP & Legacy Logs rows never appeared in it. /all_logs UNIONs both tables
// server-side and returns one paginated stream in a unified row shape, which is
// why this is an ordinary pagination module against a third endpoint rather
// than a client-side merge of the other two stores.
//
// Reachable only for super_manager / super_manager_read_only (SMS.vue picks the
// store, the endpoint enforces it) - every other role keeps the plain
// notifications/sms store on All, unchanged.
const endpoint = '/user_api/v1/sms_notifications/all_logs'
const url = (
  process.env.VUE_APP_USER_API_ENDPOINT +
  endpoint
)

const UAP_LOG_RECORD_TYPE = 'uap_log'

// Exported for the verification harness - this mapper is the whole contract
// between the union and the table.
export function parseAllLogsItems (item) {
  const errorCode = mergedErrorCode(item)
  return {
    id: item.id,
    // 'sms' | 'uap_log' - which table the row came from.
    record_type: item.record_type,
    // KPT-1121: raw - uap_log rows have no recipient email (legacy UAP or
    // warehouse SMS sent to a phone number), so their cell renders blank,
    // matching the API's null. The KPT-1117 "UAP & Legacy Logs" placeholder
    // read as data and was reported as a bug.
    user_email: item.user_email,
    // fitter_id on uap_log rows; the backend maps it.
    phone_number: item.phone_number,
    plant: item.plant,
    planner_group: item.planner_group,
    storage_location: item.storage_location,
    work_center: item.work_center,
    country: item.country,
    message: item.message,
    // Epoch millis for BOTH record types (the sms side is converted server
    // side), so this is moment's numeric path - not the ISO string path the
    // notifications/sms store uses.
    created: item.created ? moment(item.created).format('lll') : null,
    tracking_number: item.tracking_number,
    twilio_status: item.twilio_status,
    twilio_error_code: errorCode,
    twilio_error_message: item.twilio_error_message,
    // One tooltip key for both record types - the SMS Status column already
    // reads twilio_delivery_error on the general tabs.
    twilio_delivery_error: formatTwilioError(errorCode, item.twilio_error_message)
  }
}

function mergedErrorCode (item) {
  // The union already reports the UAP writer's "no error" sentinel (0) as null.
  // Kept here as well so an older backend, or a row that slipped through with a
  // literal 0, still renders no tooltip instead of "Error 0".
  if (item.record_type === UAP_LOG_RECORD_TYPE && !item.twilio_error_code) {
    return null
  }
  return item.twilio_error_code
}

export default {
  namespaced: true,
  modules: {
    allLogsPagination: createPaginationModule(
      {
        endpoint: url,
        mapper: parseAllLogsItems
      })
  },
  state: {
  },
  getters: {
    // No permission argument: the store is only ever selected for the roles
    // that may call the endpoint.
    searchSuggestionsList (state) {
      return createNotificationSmsAllLogsSuggestions()
    },
    allowedSearchInputs (state) {
      return createNotificationSmsAllLogsSearchInputs()
    }
  }
}
